import clsx from 'clsx';
import React from 'react';
import styles from '../RevenueVendorExpenseTable.module.scss';
import Tooltip from '../../../../../../common/_custom/Tooltip/Tooltip';
import { infoIconRed } from '../../../../../../assets/hostedassets';
import { OVERLAP_COLUMN_KEY, buildOverlapTooltip, isOverlappingRow, OverlapRow } from './overlap.constants';

interface RowsProps {
    rows: any;
    headers: any;
    tableRef: any;
}

function Rows(props: RowsProps) {
    const { rows, headers, tableRef } = props;
    return (
        <>
            {rows?.map?.((row, i) => (
                <React.Fragment key={i}>
                    <tr key={i} className={clsx(styles.TableBodyRow)}>
                        {headers?.map((header) => {
                            const overlapRow: OverlapRow = row;
                            const isOverlapTotal = header?.key === OVERLAP_COLUMN_KEY && isOverlappingRow(overlapRow);

                            return (
                                <td
                                    className={clsx(
                                        (row?.[header?.key]?.includes('₹') || !row?.[header?.key]) && styles.RightAligned,
                                        styles.TableBodyRowItem,
                                    )}
                                    key={`${header?.name}-${i}`}
                                >
                                    {header?.key === 'state' && row?.[header?.key] !== '-' && row?.[header?.key]?.length > 25 ? (
                                        <Tooltip content={`${row?.[header?.key]}`} direction="bottom" fitContent>
                                            <span style={{ whiteSpace: 'nowrap' }}>{row?.[header?.key]?.substring(0, 25)}...</span>
                                        </Tooltip>
                                    ) : isOverlapTotal ? (
                                        <span className={styles.OverlapTotalCell}>
                                            <span className={styles.OverlapTotal}>{overlapRow?.totalRevenue || '-'}</span>
                                            <Tooltip content={buildOverlapTooltip(overlapRow)} direction="top" usePortal fitContent>
                                                <img
                                                    src={infoIconRed}
                                                    alt="overlapping transaction info"
                                                    className={styles.OverlapInfoIcon}
                                                />
                                            </Tooltip>
                                        </span>
                                    ) : (
                                        <>{row?.[header?.key] || '-'}</>
                                    )}
                                </td>
                            );
                        })}
                    </tr>
                </React.Fragment>
            ))}
        </>
    );
}

export default Rows;
